import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const PageIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 21)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M.5.5h20v20H.5z" />
      <path d="m8.5 15.8 4.85-4.85a.43.43 0 0 0 0-.6L8.5 5.5" />
    </SVG>
  );
};
